/* Grondyke · keep the sticky header from getting stranded off-screen.

   The header is set to `sticky_header_type: on-scroll-up`, so Eurus translates it out of view
   on a downward scroll and brings it back on an upward one. Opening the cart drawer shifts the
   document's scroll position (measured at ~300px on a collection page), Eurus reads that shift
   as a downward scroll and hides the header, and closing the drawer fires no scroll event, so
   the transform is never recomputed. The header stays parked above the viewport until the
   visitor happens to scroll, and because the cart icon lives inside it they cannot reopen the
   cart in the meantime.

   The fix deliberately does NOT set a transform or force the header visible. Fighting Eurus's
   handler would mean reimplementing its rules and re-breaking them on every theme update.
   Instead this dispatches a scroll event once the drawer has closed, which makes Eurus's own
   listener recompute against the real scroll position and restore the header by its own logic.
   If Eurus decides the header should stay hidden, it stays hidden, and that is correct.

   Watched via MutationObserver rather than an Alpine store, because the drawer is injected by
   ajax after load and the store is not guaranteed to exist when this runs.
*/
(function () {
  'use strict';

  var DRAWER = '#x-cart-drawer-container';
  var settle = null;

  /* A hidden header carries a non-identity transform. Reading it is only used to decide whether
     a nudge is worth dispatching, never to set anything. */
  function headerIsHidden() {
    var h = document.querySelector('#x-header-container');
    if (!h) return false;
    return h.getBoundingClientRect().bottom <= 0;
  }

  function nudge() {
    if (!headerIsHidden()) return;
    window.dispatchEvent(new Event('scroll'));
  }

  /* The drawer animates out, so the close is not final on the first mutation. Debounce past the
     transition and nudge once things have settled, then once more a beat later to cover a slower
     animation on a cold cache. */
  function scheduleNudge() {
    if (settle) clearTimeout(settle);
    settle = setTimeout(function () {
      nudge();
      setTimeout(nudge, 400);
    }, 160);
  }

  function drawerIsOpen(root) {
    if (!root) return false;
    /* Eurus toggles the panel's visibility rather than removing it; treat any visible dialog
       inside the container as open. */
    var dialogs = root.querySelectorAll('[role="dialog"], [x-show], .cart-drawer');
    for (var i = 0; i < dialogs.length; i++) {
      var r = dialogs[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return true;
    }
    return false;
  }

  function watch() {
    var root = document.querySelector(DRAWER);
    if (!root) return false;

    var wasOpen = drawerIsOpen(root);

    new MutationObserver(function () {
      var isOpen = drawerIsOpen(root);
      if (wasOpen && !isOpen) scheduleNudge();
      wasOpen = isOpen;
    }).observe(root, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'hidden']
    });

    return true;
  }

  /* The container is rendered on every template except /cart, and is populated by ajax, so poll
     briefly for it rather than assuming it exists at DOMContentLoaded. Give up after ~10s so a
     page that genuinely has no drawer costs nothing. */
  function boot() {
    if (watch()) return;
    var tries = 0;
    var poll = setInterval(function () {
      if (watch() || ++tries > 40) clearInterval(poll);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
